import React from 'react'
import { useStaticQuery, graphql, Link } from 'gatsby'
import { Flex, Heading } from 'rebass/styled-components'
import styled from 'styled-components'

const CategoryLink = styled(Link)`
  text-decoration: none;
  color: ${({ theme }) => theme.colors.gray[700]};

  &:not(:last-child) {
    margin-bottom: 0.5rem;
  }

  &:hover {
    text-decoration: underline;
  }
`

const TagsBlock = () => {
  const data = useStaticQuery(graphql`
    query Tags {
      allTaxonomyTermTags(filter: {relationships: {node__blog_post: {elemMatch: {title: {ne: null }}}}}, limit: 25) {
        edges {
          node {
            name
            path {
              alias
            }
          }
        }
      }
    }
  `)
  return (
    <Flex flexDirection="column" px={2}>
      <Heading mb={3}>Тэги</Heading>
      {data.allTaxonomyTermTags.edges.map(({ node }) => (
        <CategoryLink key={node.name} to={node.path.alias}>{node.name}</CategoryLink>
      ))}
    </Flex>
  )
}

export default TagsBlock
